import React, { Component } from "react";
import {FaMusic, FaCalendar, FaLaptop, FaGuitar } from "react-icons/fa";
import Title from "./Title";
import { Link } from "react-router-dom";

export default class Pricing extends Component {
 state = {
    services: [
      {
        icon: <FaMusic />,
        price : 1300,
        priceYearly : 12480,
        title: "economy",
        aboutplna: "economy",
        info:
          "List your your studio and increase your bookings"
      },
      {
        icon: <FaCalendar />,
        price : 1500,
         priceYearly : 14400,
        title: "standard",
        info:
          "List your your studio and increase booking,this comes with marketing & advertisment, artists access your studio calendar in the cloud. This is enables high level studio efficieny "
      },
      {
        icon: <FaLaptop />,
        price : 3000,
        priceYearly : 28800,
        title: "deluxe",
        info:
          "List your your studio and increase booking, marketing , advertisment, artists access your studio calendar in the cloud and also include social media marketing for your studios we publish , share content on your  twitter, facebook. We schedule post so that they are posted at the right time. we finally offer Analysis on  the social media marketing effort ! "
      },
      {
        icon: <FaGuitar />,
        price : 6000,
        priceYearly : 57600,
        title: "premium",
        info:
          "List your your studio and increase booking, marketing , advertisment, artists access your studio calendar in the cloud and also include social media marketing for your studios we publish , share content on your  twitter, facebook. We schedule post so that they are posted at the right time. we finally offer Analysis on  the social media marketing effort !. With this plan you got to enjoy the peace of mind that comes with using our platforms messaging, booking management tools and dedicated support team"
      }
    ]
  };
 render() {
    return (
      <section className="services">
        <Title title="choose a plan that is best for your studio" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
                <br/>
                <h6>Ksh.{item.price}/month</h6>
                <p>or</p>
                <br/>
                <h6>Ksh.{item.priceYearly}/year <br/><small>(20% discount)</small></h6>
              
               <Link to="/register" className="btn-primary">
            select
          </Link>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
